// extracted by mini-css-extract-plugin
export default {"spends_home_container":"Home_spends_home_container__9bElu","top_categories_div":"Home_top_categories_div__nDDzU","top_categories_item":"Home_top_categories_item__x1Wln"};